<div class="button-container" [class.disabled-state]="isDisabled">
  <!-- Disabled overlay message -->
  <div class="disabled-overlay" *ngIf="isDisabled">
    <span class="disabled-message">{{ disabledMessage }}</span>
  </div>

  <button [ngClass]="fullButtonClass" type="button" [disabled]="isDisabled" (click)="onClick()">
    {{ buttonText }}
  </button>
</div>
